import { ConversationGetByIdExpression } from "../../../Models/Conversations/ConversationGetExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { ApiServices, ApiServicesKey } from "../DomainServices/DomainServiceOperationCallExpressionEvaluator";

export class ConversationGetByIdExpressionEvaluator implements IExpressionEvaluator<ConversationGetByIdExpression> {
    get type(): string {
        return "Conversation.GetById";
    }

    async evaluate(expression: ConversationGetByIdExpression, context: IExpressionEvaluatorContext): Promise<any> {
        const { conversationClient, errorHandler } = context.GetProperty<ApiServices>(ApiServicesKey);

        try {
            const conversationId = await context.Evaluator.evaluate(expression.ConversationId, context);
            const conversation = await conversationClient.getById(conversationId, undefined);
            return conversation;
        } catch (error) {
            errorHandler(error);
            throw error;
        }
    }
}
